<template>
  <div class="box_content">
    <div class="link_user_box">
      <Cards :isShowTitle="false">
        <div class="top_tools">
          <el-button size="small" type="primary" :icon="CirclePlus" @click="addFollowForm" style="margin-right: 10px">
            {{ $t('add.new.follow') }}
          </el-button>
          <el-button size="small" type="danger" :icon="Delete" @click="checkDelete">
            {{ $t('common.delete') }}
          </el-button>
        </div>
        <el-table
            ref="multipleTableRef"
            :data="tableDataLogs"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :v-loading="isLoadingLog"
            :cell-style="rowClassName"
            :header-cell-style="headerClassName"
            :row-key="row => row.id"
            @cell-mouse-leave="clearVisiblePopover"
        >
          <el-table-column type="selection" :reserve-selection="true" fixed="left">
          </el-table-column>
          <el-table-column
              v-for="item in table_columns_logs"
              :key="item.key"
              :label="item.key"
              :prop="item.value"
              :width="handleClickSelectWidth(item)"
          >
            <template #default="{row,column,$index}">
              <template v-if="item.value==='mailCustomerFollowContactDTOList'">
                <el-popover
                    placement="bottom-start"
                    :width="'max-content'"
                    :effect="'dark'"
                    :show-after="1200"
                    trigger="hover"
                >
                  <div
                      v-html="
                          '<div>' +
                          row.mailCustomerFollowContactDTOList
                            .map((item) => {
                              return `${item.contactName}<br/>`;
                            })
                            .join('') +
                          '</div>'
                        "
                  ></div>
                  <template #reference>
                    <el-button type="primary" link>{{ row.mailCustomerFollowContactDTOList.length }}</el-button>
                  </template>
                </el-popover>
              </template>
              <template v-else-if="item.value==='followDetail'">
                <div :ref="ref => (refMap[`${row.id}_detail`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_detail`], row, 1)"
                     v-if="getTextWidth(row.followDetail)>= middleValueWidth"
                     class="over_normal"
                     :key="row.followDetail">
                  {{
                    row.followDetail
                  }}
                </div>
                <div v-else>
                  {{ row.followDetail }}
                </div>
              </template>
              <template v-else-if="item.value==='remark'">
                <div :ref="ref => (refMap[`${row.id}_remark`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_remark`], row, 1)"
                     v-if="getTextWidth(row.remark)>= middleValueWidth"
                     class="over_normal"
                     :key="row.remark">
                  {{
                    row.remark
                  }}
                </div>
                <div v-else>
                  {{ row.remark }}
                </div>
              </template>
              <template v-else-if="item.value==='followWay'">
                <div :ref="ref => (refMap[`${row.id}_followWay`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_followWay`], row, 3)"
                     v-if="getTextWidth(row.followWay)>= middleValueWidth"
                     class="over_normal"
                     :key="row.followWay">
                  {{
                    row.followWay
                  }}
                </div>
                <div v-else>
                  {{ row.followWay }}
                </div>
              </template>
              <template v-else-if="item.value==='followAim'">
                <div :ref="ref => (refMap[`${row.id}_followAim`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_followAim`], row, 4)"
                     v-if="getTextWidth(row.followAim)>= middleValueWidth"
                     class="over_normal"
                     :key="row.followAim">
                  {{
                    row.followAim
                  }}
                </div>
                <div v-else>
                  {{ row.followAim }}
                </div>
              </template>
              <template v-else-if="item.value==='createName'">
                <div :ref="ref => (refMap[`${row.id}_createName`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_createName`], row, 5)"
                     v-if="getTextWidth(row.createName)>= middleValueWidth"
                     class="over_normal"
                     :key="row.createName">
                  {{
                    row.createName
                  }}
                </div>
                <div v-else>
                  {{ row.createName }}
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$t('common.operate')" :width="140">
            <template #default="{row,column,$index}">
              <el-button link type="primary" @click="editRowItem(row)">{{ $t('common.edit') }}</el-button>
              <el-button link type="primary" @click="showDetail(row)">{{ $t('common.details') }}</el-button>
              <el-popover
                  :visible="row.popoverVisible"
                  placement="top"
                  :width="164"
                  trigger="click"
              >
                <div class="inners">
                  <el-icon>
                    <WarningFilled/>
                  </el-icon>
                  <p>{{ $t('sys.message.ask.type.delete') }}</p>
                </div>
                <div style="text-align: center; margin-top:10px">
                  <el-button
                      size="small"
                      text
                      @click="cancelPopover(row, column, $index)"
                  >{{ $t('common.cancel') }}
                  </el-button
                  >
                  <el-button
                      size="small"
                      type="primary"
                      v-loading="rowDelete"
                      @click="handleDelete(row, column, $index)"
                  >{{ $t('common.confirm') }}
                  </el-button
                  >
                </div>
                <template #reference>
                  <el-button
                      type="danger"
                      link
                      @click="requestHandleDelete(row, column, $index)"
                  >{{ $t('common.delete') }}
                  </el-button
                  >
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty
                :description="$t('common.data.empty')"
                :image="emptyUrl"
            />
          </template>
        </el-table>
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
              size="small"
              v-model:current-page="pageNo"
              v-model:page-size="pageSize"
              background
              layout="total, prev, pager, next"
              v-if="total"
              :total="total"
              @current-change="handleCurrentChange"
          />
        </div>
      </Cards>
    </div>
    <CreateFollowDetail v-if="followVisible" v-model="followVisible" @close="closeFollow"
                        :isHeadLine="false"
                        :dialogFlag="dialogFlag"
                        :currentItemDetail="currentItemDetail"
                        @getList="getQueryPageList"
    >
    </CreateFollowDetail>

    <DeleteFollowItem v-if="followVisibleDelete" v-model="followVisibleDelete" @close="closefollowVisibleDelete"
                      :is-head-line="true" :multipleSelection="multipleSelection"
                      @getList="getQueryPageList"></DeleteFollowItem>


    <el-popover
        v-model:visible="visiblePopover"
        :virtual-ref="tempRef"
        virtual-triggering
        :width="'max-content'"
        trigger="hover"
        :popper-style="{minWidth:'60px',width:'auto'}"
        effect="dark"
        placement="right"
        :show-after="1200"
    >
      <template v-if="popoverType === 1">
        <div class="popover-content">
          <!-- 业务逻辑1 -->
          {{ activeItemElpopover.followDetail }}
        </div>
      </template>
      <template v-else-if="popoverType === 2">
        <!-- 业务逻辑2 -->
        <div class="popover-content">
          {{ activeItemElpopover.remark }}
        </div>
      </template>
      <template v-else-if="popoverType === 3">
        <!-- 业务逻辑2 -->
        <div class="popover-content">
          {{ activeItemElpopover.followWay }}
        </div>
      </template>
      <template v-else-if="popoverType === 4">
        <!-- 业务逻辑2 -->
        <div class="popover-content">
          {{ activeItemElpopover.followAim }}
        </div>
      </template>
      <template v-else-if="popoverType === 5">
        <!-- 业务逻辑2 -->
        <div class="popover-content">
          {{ activeItemElpopover.createName }}
        </div>
      </template>
    </el-popover>
  </div>
</template>
<script setup>
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {ElMessage, ElTable} from "element-plus";
import Cards from "@/views/Customer/Cards.vue";
import {CirclePlus, Delete} from "@element-plus/icons-vue";
import {onMounted, ref} from "vue";
import CreateFollowDetail from "@/components/DiaPops/CreateFollowDetail.vue";
import {auto} from "@popperjs/core";
import {flexWidth} from "@/utils/tableWidth";
import {deleteBatchFollow, getMailCustomerContactByCustomerId, queryPageList} from "@/api/customer";
import {useRoute} from "vue-router";
import DeleteFollowItem from "@/components/DiaPops/DeleteFollowItem.vue";
import {i18n} from "@/lang";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";
import {debouncePlus} from "@/utils/mylodash";

const route = useRoute();

const tableDataLogs = ref([])

const table_columns_logs = ref([
  {key: i18n.global.t('follow.date'), value: 'followTime'},
  {key: i18n.global.t('common.contact'), value: 'mailCustomerFollowContactDTOList'},
  {key: i18n.global.t('follow.ways'), value: 'followWay'},
  {key: i18n.global.t('follow.target'), value: 'followAim'},
  {key: i18n.global.t('setting.user'), value: 'createName'},
  {key: i18n.global.t('follow.detail'), value: 'followDetail'},
  {key: i18n.global.t('common.remark'), value: 'remark'}
])


const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const followVisible = ref(false)
// create / edit / detail
const dialogFlag = ref('')
const addFollowForm = async () => {
  followVisible.value = true;
  dialogFlag.value = 'create'
}

const currentItemDetail = ref({})
const showDetail = (row) => {
  followVisible.value = true;
  currentItemDetail.value = row;
  dialogFlag.value = 'detail'
}
const editRowItem = (row) => {
  followVisible.value = true;
  currentItemDetail.value = row;
  dialogFlag.value = 'edit'
}

const deleteTargetItem = (row) => {
  console.log(row, 'row')
}
const closeFollow = () => {
  followVisible.value = false;
}

const multipleSelection = ref([])
const handleSelectionChange = (val) => {
  multipleSelection.value = val;
}


const followVisibleDelete = ref(false)
const closefollowVisibleDelete = () => {
  followVisibleDelete.value = false
}
const checkDelete = async () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t('follow.log.delete'))
    return
  }
  followVisibleDelete.value = true
}


const cancelPopover = async (row) => {
  row.popoverVisible = false;
};

// 删除 单行
const rowDelete = ref(false)
const handleDelete = async (row, column, index) => {
  const {id} = row;
  try {
    rowDelete.value = true
    await deleteBatchFollow({ids: [id]});
    ElMessage.success(i18n.global.t('sys.message.success.delete'));
    rowDelete.value = false
    row.popoverVisible = false;
    await getQueryPageList()
  } catch (e) {
    ElMessage.error(e)
    rowDelete.value = false
  }
};


const requestHandleDelete = (row) => {
  row.popoverVisible = true;
}


// 获取列表
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const isLoadingLog = ref(false)
const getQueryPageList = async () => {
  const payload = {
    customerId: route.params.userId,
    pageNo: pageNo.value,
    pageSize: pageSize.value,
  }
  try {
    isLoadingLog.value = true
    let res = await queryPageList(payload)
    console.log(res, 'res')
    total.value = res.result.total;
    pageNo.value = res.result.current;
    tableDataLogs.value = res.result.records;
    isLoadingLog.value = false
  } catch (e) {
    isLoadingLog.value = false
  }
}

async function handleCurrentChange(page) {
  pageNo.value = page;
  await getQueryPageList()
}

onMounted(async () => {
  await getQueryPageList()
})


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 2 || columnIndex === 5) {
    return {textAlign: 'center'}
  } else {
    return {textAlign: 'left'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 2 || columnIndex === 5) {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}


const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}

// 设置 临界值 width
const middleValueWidth = ref(120)
const sizeMaxNumber = ref(13)
const handleClickSelectWidth = (item) => {
  if (item.value === "createName") {
    console.log(flexWidth('createName', tableDataLogs.value, i18n.global.t('setting.user')), 'asdfasf')
    if (flexWidth('createName', tableDataLogs.value, i18n.global.t('setting.user')) > middleValueWidth.value) {
      return middleValueWidth.value
    } else {
      if (flexWidth('createName', tableDataLogs.value, i18n.global.t('setting.user')) < 80) {
        return 80
      } else {
        // 添加修正值
        return flexWidth('createName', tableDataLogs.value, i18n.global.t('setting.user')) + 10
      }
    }
  } else if (item.value === 'followWay') {
    return flexWidth('followWay', tableDataLogs.value, i18n.global.t('follow.ways')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('followWay', tableDataLogs.value, i18n.global.t('follow.ways'))
  } else if (item.value === 'followAim') {
    return flexWidth('followAim', tableDataLogs.value, i18n.global.t('follow.target')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('followAim', tableDataLogs.value, i18n.global.t('follow.target'))
  } else if (item.value === 'mailCustomerFollowContactDTOList') {
    return 80
  } else if (item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else {
    return "auto"
  }
}
</script>
<style lang="less" scoped>
@import "../../../less/page.less";

.box_content {
  width: 100%;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

.top_tools {
  padding-bottom: 16px;
  background: white;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

:deep(.el-popper) {
  max-width: 40% !important;
  max-height: 80px !important;
  overflow: scroll;
}

.inners {
  display: flex;
  justify-content: center;
  align-items: center;

  & > .el-icon {
    color: #faad14;
    margin-right: 2px;
  }
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>